import cn from 'classnames';
import React from 'react';
import { RouteChildrenProps } from 'react-router';
import { Routes } from 'src/shared/Routes';
import { locationInRoutes } from 'src/shared/utils/RouteUtilities';
import { useIsOnSearchPage } from 'src/shared/utils/SearchUtils';
import { useCachedZipCode } from 'src/user-preferences/useCachedZipCode';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';
import { DishFirstHeader, NAV_HEIGHT, NAV_HEIGHT_LARGE } from '../DishFirstHeader';
import { usePromoReducer } from '../DishFirstHeader/store';

interface IProps extends Pick<RouteChildrenProps, 'location'> {
  backgroundRef: React.RefObject<HTMLDivElement>;
  hideSearchAndSignup?: boolean;
}

const ConsumerHeaderWrapper: React.FC<IProps> = ({ location, backgroundRef, hideSearchAndSignup = false }) => {
  const header = <DishFirstHeader backgroundRef={backgroundRef} hideSearchAndSignup={hideSearchAndSignup} />;
  const { isSmallScreen } = useScreenContext();
  const { isExpanded, isShowing } = usePromoReducer();
  const [cachedZipCode] = useCachedZipCode();
  const { isOnSearchPageMobile } = useIsOnSearchPage();
  const isHeaderVisible = !locationInRoutes(location, [
    Routes.CONSUMER_ORDER_CART,
    Routes.CONSUMER_ORDER_FINALIZE,
    Routes.CONSUMER_SUBSCRIPTION_WIZARD_PAGE,
    Routes.CONSUMER_SUBSCRIPTION_RECEIPT,
    Routes.CONSUMER_MEAL_PLANS,
    Routes.CONSUMER_MEAL_PLANS_MANAGE,
    Routes.CONSUMER_MEAL_PLANS_MANAGE_DELIVERY,
    Routes.CONSUMER_MEAL_PLANS_MANAGE_PLAN,
    Routes.CONSUMER_MEAL_PLANS_MANAGE_TASTE_PROFILE,
  ]);

  const promoIsVisible = isShowing && !hideSearchAndSignup && Boolean(cachedZipCode);

  return !isHeaderVisible ? null : (
    <>
      {header}
      <div id='SPACER' style={{ height: isOnSearchPageMobile ? NAV_HEIGHT_LARGE : NAV_HEIGHT }} />
      <div
        id='promoSpacer'
        className={cn({
          'h-14': !isSmallScreen && promoIsVisible && !isExpanded,
          'h-[244px]': !isSmallScreen && promoIsVisible && isExpanded,
          'h-[76px]': isSmallScreen && promoIsVisible && !isExpanded,
          'h-[264px]': isSmallScreen && promoIsVisible && isExpanded,
          'h-0': !promoIsVisible,
        })}
      />
    </>
  );
};

export default ConsumerHeaderWrapper;
